import { Card, CardContent } from '../ui/card';

const testimonials = [
  {
    quote: "The facilitators beautifully combined sport, leadership, and personal growth. I left not only a better player but also more attuned to how I show up in my relationships and work.",
    name: "Erik K."
  },
  {
    quote: "A magical experience and a safe space to explore new skills on the court while discovering new ways of seeing myself and how I relate to others.",
    name: "David H."
  },
  {
    quote: "I really enjoyed the Paradox of Pickleball. Combining the sport with the mental game (both in sport and life) is a great concept.",
    name: "Robyn M."
  },
  {
    quote: "The program was a unique and eye-opening experience that tied lessons on the court to life beyond it. I walked away more grounded, calm, and intentional.",
    name: "Staci S."
  }
];

const PickleballTestimonials = () => {
  return (
    <section className="container-mobile section-spacing max-w-5xl mx-auto">
      <div className="text-center mb-12">
        <p className="text-primary font-semibold tracking-[0.15em] uppercase text-sm mb-2">
          What Players Say
        </p>
        <h2 className="text-foreground">Voices From the Court</h2>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        {testimonials.map((t, i) => (
          <Card key={i} className="bg-card border border-border">
            <CardContent className="p-8">
              <p className="text-foreground/70 italic leading-relaxed mb-4 font-display">
                "{t.quote}"
              </p>
              <p className="text-primary font-semibold text-sm">{t.name}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default PickleballTestimonials;
